import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Button, TextField } from '@mui/material';
import { getImage } from '../../server/server';

import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { getSymbolsPagination } from '../../server/server';
import useDebounce from '../../hooks/useDebounce';

function AddSymbolModal({ modalIsOpen, closeModal, selectSymbol }: any) {
	const [symbols, setSymbols] = useState([]);
	const [rowCountState, setRowCountState] = useState(5);
	const [isLoading, setIsLoading] = useState(true);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedSymbols, setSelectedSymbols] = useState<any[][]>([[]]);
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 5,
	});
	const searchDelay = 2000;
	const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);
	const debouncedQuery = useDebounce(searchQuery, searchDelay);

	useEffect(() => {
		if (modalIsOpen) {
			ReactModal.setAppElement('#root');
			loadSymbolsList(paginationModel.page, paginationModel.pageSize, debouncedQuery);
		}
	}, [modalIsOpen]);

	useEffect(() => {
		if (modalIsOpen) {
			loadSymbolsList(paginationModel.page, paginationModel.pageSize, debouncedQuery);
		}
	}, [paginationModel.page, paginationModel.pageSize, debouncedQuery]);

	const loadSymbolsList = async (page?: any, pageSize?: any, searchQuery?: any) => {
		setIsLoading(true);
		const resp = await getSymbolsPagination(pageSize, page * pageSize, searchQuery);
		if (resp.status === 200) {
			setSymbols(resp.data.data);
			setRowCountState(resp.data.size);
			setIsLoading(false);
		}
	};

	const onSubmit = async () => {
		const id = rowSelectionModel[0];
		const image = (symbols.find((symbol: any) => symbol.id === id) as any)?.image;
		selectSymbol(image);
		closeModal();
	};

	const reset = () => {
		setRowSelectionModel([]);
		setSelectedSymbols([[]]);
		setPaginationModel({
			page: 0,
			pageSize: 5,
		});
		setSymbols([]);
	};

	const columns: GridColDef[] = [
		{
			field: 'image',
			headerName: 'Image',
			renderCell: (params) => <img src={getImage(params.value)} alt="Icon" className=" h-[94%]" />,
			filterable: false,
			sortable: false,
			disableColumnMenu: true,
		},
		{ field: 'name', headerName: 'Symbol Category name', flex: 1, sortable: false, disableColumnMenu: true },
	];
	return (
		<ReactModal
			ariaHideApp={false}
			//closeTimeoutMS={600}
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => reset()}
			onRequestClose={closeModal}
			className="no-scroll"
			style={{
				overlay: {
					zIndex: 5,
					backdropFilter: 'brightness(30%)',
				},
				content: {
					padding: 0,
					opacity: 1,
					width: 950,
					margin: 'auto',
					backgroundColor: 'transparent',
					height: '100%',
					maxHeight: '100%',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
					paddingTop: 15,
					paddingBottom: 15,
				},
			}}
		>
			<div className="   max-h-[600px] w-full  ">
				<div className=" flex flex-1 flex-col gap-5 rounded-[10px] bg-white  px-[40px] py-[30px] ">
					<p className=" text-center text-xl ">Add Symbols for product design</p>
					<TextField label="Search" variant="outlined" value={searchQuery} onChange={(e: any) => setSearchQuery(e.target.value)} style={{ marginRight: '5px' }} />
					<div className="mt-5 h-fit w-full">
						<DataGrid
							autoHeight
							rowHeight={80}
							checkboxSelection
							rowCount={rowCountState}
							loading={isLoading}
							disableRowSelectionOnClick
							pagination
							rows={symbols}
							columns={[...columns]}
							showCellVerticalBorder={false}
							style={{ minHeight: 371 }}
							pageSizeOptions={[5, 15, 25]}
							paginationModel={paginationModel}
							paginationMode="server"
							rowSelectionModel={rowSelectionModel}
							onRowSelectionModelChange={(newRowSelectionModel: GridRowSelectionModel) => {
								console.log(newRowSelectionModel);

								if (newRowSelectionModel.length >= 1) {
									setRowSelectionModel([newRowSelectionModel[newRowSelectionModel.length - 1]]);
								} else {
									setRowSelectionModel([]);
								}
								// setRowSelectionModel(newRowSelectionModel);
								// let list: any[] = [...newRowSelectionModel];
								// selectedSymbols[paginationModel.page] = list;
							}}
							onPaginationModelChange={(newModel) => {
								if (newModel.pageSize !== paginationModel.pageSize) {
									setSelectedSymbols([[]]);
									setPaginationModel({
										page: 0,
										pageSize: newModel.pageSize,
									});
									return;
								} else {
									setPaginationModel(newModel);
									if (newModel.page + 1 > selectedSymbols.length) {
										setSelectedSymbols([...selectedSymbols, []]);
									}
								}
							}}
						/>
					</div>
					<div className="flex w-full flex-row justify-end gap-8 mt-10  ">
						<Button variant="contained" onClick={() => closeModal()} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
							Cancel
						</Button>
						<Button variant="contained" onClick={() => onSubmit()} style={{ backgroundColor: '#2ec4b6', color: 'white' }} disabled={rowSelectionModel.length === 0}>
							Submit
						</Button>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default AddSymbolModal;
